import ExtraDataButton from '@common-components/tasks/extra-data-button/extraDataButton'
import React from 'react'
import { CellProps } from '../cell-interface'

export default function ChatCell({ taskId }: CellProps) {
  return (
    <ExtraDataButton taskId={taskId} />
  )
}